import { ThemeProvider } from "@mui/material";
import theme from "./Theme/theme";
import { BrowserRouter as Router } from "react-router-dom";
import { createContext, useState } from "react";
import DataFormatter from "./Component/dataFormatter";
import { FormatorContextInterface } from "./Interface/interface";

export const Context = createContext<FormatorContextInterface>({
  inputcode: "",
  setInputCode: () => {},
  beautifiedCode: "",
  setBeautifiedCode: () => {},
  urlType: "",
  setUrlType: () => {},
  showJsonDataType: false,
  setShowJsonDataType: () => {},
  showObjectSize: true,
  setShowObjectSize: () => {},
  inputFileData: undefined,
  setInputFileData: () => {},
  htmlRunView: false,
  sethtmlRunView: () => {},
  // inputUrlData: null,
  // setInputUrlData: () => {}
});

function App() {
  const [inputcode, setInputCode] = useState("");
  const [beautifiedCode, setBeautifiedCode] = useState("");
  const [urlType, setUrlType] = useState<string>("");
  const [showJsonDataType, setShowJsonDataType] = useState(false);
  const [showObjectSize, setShowObjectSize] = useState(true);
  const [inputFileData, setInputFileData] = useState<string | undefined>(undefined);
  const [htmlRunView, sethtmlRunView] = useState<boolean>(false);
  //const [inputUrlData, setInputUrlData] = useState<string | null>(null);

  return (
    <Context.Provider
      value={{
        inputcode,
        setInputCode,
        beautifiedCode,
        setBeautifiedCode,
        urlType,
        setUrlType,
        showJsonDataType,
        setShowJsonDataType,
        showObjectSize,
        setShowObjectSize,
        inputFileData,
        setInputFileData,
        htmlRunView,
        sethtmlRunView,
        // inputUrlData,
        // setInputUrlData
      }}
    >
      <Router>
        <ThemeProvider theme={theme}>
          <DataFormatter />
        </ThemeProvider>
      </Router>
    </Context.Provider>
  );
}

export default App;
